import { ArrowRightIcon, IconButton, Theme, Tooltip, makeStyles } from '@forgeglobal/design-framework'
import { CellRendererParams } from './CellRendererParams'
import { Link } from 'react-router-dom'
import React from 'react'

const useStyles = makeStyles((theme: Theme) => ({
  link: {
    textDecoration: 'none',
    display: 'flex',
  },
}))

export const LinkRenderer = (params: CellRendererParams<string>) => {
  const styles = useStyles()
  return (
    <Tooltip title="View more" placement="left" enterDelay={1000}>
      <Link to={params.value} className={styles.link}>
        <IconButton>
          <ArrowRightIcon />
        </IconButton>
      </Link>
    </Tooltip>
  )
}
